import type { TwoUserStackProps } from "@circle-react-uikit/TwoUserStack";
import { TwoUserStack } from "@circle-react-uikit/TwoUserStack";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

type Users = TwoUserStackProps["users"];

interface User {
  avatar_url: string;
  name: string;
}

interface GroupUserImageProps {
  className?: string;
  user1: User;
  user2: User;
}

/**
 * This component is deprecated.
 *
 * Use {@link @circle-react-uikit/TwoUserStack} component instead
 */
export const GroupUserImage = ({
  user1,
  user2,
  className = "",
}: GroupUserImageProps) => {
  const users: Users = [
    { name: user1?.name || "", src: user1?.avatar_url || "" },
    { name: user2?.name || "", src: user2?.avatar_url || "" },
  ];

  return (
    <div className={classNames("border-tertiary max-h-10", className)}>
      <TwoUserStack users={users} isFullRounded />
    </div>
  );
};
